// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Td_wrapper__1ev8l","centered":"Td_centered__1AyP4","noPointer":"Td_noPointer__gvWHx"};